import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'neoris-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent  {

  constructor() { 
    console.log('constructor')
  }


}
